import {  
    getFirestore,
    doc,
    collection,
    addDoc,
    setDoc
} from "firebase/firestore";
    const getQuizList = async function(data, quizId) {

    let db = getFirestore();
    let quizRef = collection(db, "wellness_quiz");
    if( quizId != undefined ){
        quizRef = doc(db, "wellness_quiz", quizId );
        await setDoc(quizRef, data);
    }
    else{
        await addDoc(quizRef, data);
    }
};
export default getQuizList;